import { render } from "./DeleteActionModal.vue?vue&type=template&id=4110cc31&scoped=true"
import script from "./DeleteActionModal.vue?vue&type=script&lang=js"
export * from "./DeleteActionModal.vue?vue&type=script&lang=js"

import "./DeleteActionModal.vue?vue&type=style&index=0&id=4110cc31&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4110cc31"]])

export default __exports__